/**
 * Mutación que sirve para guardar la lista de transacciones de un evento.
 * @param {State} state Estado de Vue
 * @param {Array<Object>} orderInformation Lista de ordenes de un evento (LA LISTA ES MOSTRADA EN LA TABLA DE ÚLITMAS TRANSACCIONES)
 */
export function setOrderInformation(state, orderInformation) {
    state.orders = orderInformation
}

/**
 * Mutación para guardar las ventas de un evento en especifico y mostrarlas en la gráfica circular.
 * @param {State} state Estadode vue
 * @param {Array<Object>} ordersEventDoughnutChart Arreglo de objetos 
 */
export function setOrdersEventDoughnutChart(state, ordersEventDoughnutChart) {
    state.ordersEventDoughnutChart = ordersEventDoughnutChart;
}

/**
 * Mutación que sirve para acumular ordenes de un evento en la tabla de últimas transacciones (SOLO APLICA CUANDO UN EVENTO CUENTA CON MÁS DE 400 TRANSACCIONES).
 * @param {State} state Estado de Vue
 * @param {Array<Object>} orderInformation Lista de ordenes de un evento (LAS ORDENES OBTENIDAS SON DE BLOQUES DE 400)
 */
export function setMoreOrderInformation(state, orderInformation) {
    state.orders = state.orders.concat(orderInformation);
}

/**
 * Mutación para guardar la lista de boletos de los eventos disponibles de un organizador.
 * @param {State} state Estado de Vue.
 * @param {Array<Object>} ticketsInventory Lista de boletos de eventos disponibes de la organización.
 */
export function setTicketsInventory(state, ticketsInventory) {
    state.ticketsInventory = ticketsInventory
}